import api from '../core/api';
import VwMbsMuhasebeislemDTO from 'src/models/MuhasebeIslemler/VwMbsMuhasebeislemDTO';
import MuhasebeIslemlerSlice, { MuhasebeIslemlerSearch } from 'src/store/Slices/MuhasebeIslemler/MuhasebeIslemlerSlice';
import { ApiRequest } from 'src/models/api.request';
import { helper } from 'src/utils/helper';
import { useAppSelector } from 'src/store';
import VwKullaniciDTO from 'src/models/Base/Auth/VwKullaniciDTO';
import VwVtysgrupDTO from 'src/models/RolYetki/VwVtysGrup';
import VwKullanicivtysgrupDTO from 'src/models/RolYetki/VwKullanicivtysgrupDTO';
import VwKullanicivtyslistDTO from 'src/models/RolYetki/VwKullanicivtyslistDTO';

export const KullaniciApi = api.injectEndpoints({
  endpoints: (builder) => ({
    KullaniciList: builder.query<Array<VwKullaniciDTO>, { id: number; aktif: string }>({
      query: (request) => {
        let req: ApiRequest<VwKullaniciDTO> = {
          filters: {
            groupOperator: 'and',
            predicates: [{ fieldName: 'aktif', operator: '=', value1: request.aktif }]
          },
          sorts: [{ fieldName: 'id', ascending: false }]
        };
        if (request.id > 0)
          req.filters.predicates.push({
            fieldName: 'id',
            operator: '=',
            value1: request
          });

        return {
          url: 'Account/find',
          method: 'POST',
          body: JSON.stringify(req)
        };
      },
      providesTags: ['KullaniciList']
      // keepUnusedDataFor: 0
    }),

    VtysGrupList: builder.query<Array<VwKullanicivtysgrupDTO>, { id: number; vtysGrup: number; aktif: string }>({
      query: (request) => {
        let req: ApiRequest<VwVtysgrupDTO> = {
          filters: {
            groupOperator: 'and',
            predicates: []
          },
          sorts: [{ fieldName: 'id', ascending: false }]
        };

        if (request.aktif == 'E')
          req.filters.predicates.push({
            fieldName: 'aktif',
            operator: '=',
            value1: request.aktif
          });

        if (request.id > 0)
          req.filters.predicates.push({
            fieldName: 'id',
            operator: '=',
            value1: request.id
          });

        if (request.vtysGrup > 0)
          req.filters.predicates.push({
            fieldName: 'vtysgrup',
            operator: '=',
            value1: request.vtysGrup
          });

        return {
          url: 'VwKullanicivtysgrupDTO/find',
          method: 'POST',
          body: JSON.stringify(req)
        };
      }
    }),

    KullaniciVTYSList: builder.query<Array<VwKullanicivtyslistDTO>,{ id: number; tipId: number; orgId: number; kullaniciId: number }>({
      query: (request) => {
        let req: ApiRequest<VwKullanicivtyslistDTO> = {
          filters: {
            groupOperator: 'and',
            predicates: []
          },
          sorts: [{ fieldName: 'id', ascending: false }]
        };

        if (request.tipId > 0)
          req.filters.predicates.push({
            fieldName: 'tipId',
            operator: '=',
            value1: request.tipId
          });

        if (request.id > 0)
          req.filters.predicates.push({
            fieldName: 'id',
            operator: '=',
            value1: request.id
          });

        if (request.kullaniciId > 0)
          req.filters.predicates.push({
            fieldName: 'kullaniciId',
            operator: '=',
            value1: request.kullaniciId
          });

        if (request.orgId > 0)
          req.filters.predicates.push({
            fieldName: 'organizasyonId',
            operator: '=',
            value1: request.orgId
          });

        return {
          url: 'VwKullanicivtyslistDTO/find',
          method: 'POST',
          body: JSON.stringify(req)
        };
      },
      providesTags: ['KullaniciVtysList']
    }),

    KullaniciVYSEkle: builder.mutation<VwKullanicivtyslistDTO, VwKullanicivtyslistDTO>({
        query: (request) => {
            return {
                url: "VwKullanicivtyslistDTO",
                method: "POST",
                body: JSON.stringify(request)
            }
        },
    }),

    KullaniciVYSil: builder.mutation<boolean, number>({
        query: (id) => {
            return {
                url: "VwKullanicivtyslistDTO/" + id,
                method: "DELETE",
            }
        },
    }),
  })
});

export const { useKullaniciListQuery, useVtysGrupListQuery, useKullaniciVTYSListQuery, useKullaniciVYSilMutation, useKullaniciVYSEkleMutation } = KullaniciApi;
